<template>
  <div class="box">
    <div class="search">
      <el-input v-model="Switch.name" class="width" clearable placeholder="图片的名称"></el-input>
      <el-button type="primary" class="left" @click="list">查询</el-button>
      <el-button type="primary" class="left" @click="neir = true">新增</el-button>
      <el-button type="danger" class="left" @click="delect">删除</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="序号" width="80"></el-table-column>
        <el-table-column prop="name" label="图片名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pids" label="被引用模块" show-overflow-tooltip></el-table-column>
        <el-table-column prop="width" label="图片宽度" show-overflow-tooltip></el-table-column>
        <el-table-column prop="height" label="图片高度" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
             <el-button class="left" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        :title="id ? '编辑' : '新增'"
        :show-close="false"
        :visible.sync="neir"
        :close-on-click-modal="false"
        width="25%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
            <el-form-item label="图片名称" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="pic">
                <el-upload
                    action=""
                    ref="pic"
                    :auto-upload="false"
                    v-model="ruleForm.pic"
                    list-type="picture-card"
                    :limit="1"
                    :file-list="fileList"
                    :on-change="getFile"
                    :before-remove="remove">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="neir = false">取 消</el-button>
            <el-button type="primary" @click="update">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Switch: {
        name: ''
      },
      ruleForm: {
        name: '',
        pic: ''
      },
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传图片', trigger: 'change' }]
      },
      Select: [],
      fileList: [],
      id: null,
      neir: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      total: 0
    }
  },
  created() {
    this.list()
  },
  methods: {
    // 列表数据
    async list() {
      this.loading = true
      let res = await this.$http.post('/picLibrary/getPicLibrary', {
        name: this.Switch.name ? this.Switch.name : null,
        current: this.currentPage,
        size: 10
      })
      this.loading = false
      if(res.data.code == 200) {
        this.tableData = res.data.data
        this.total = res.data.count
      }
    },
    handleSelectionChange(news) {
      this.Select = []
      news.forEach(item => {
        this.Select.push(item.id)
      });
    },
    getBase64(file) {   // 公共方法 -> 获取图片转base64
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    getFile(file) {
      this.getBase64(file.raw).then((res) => {
        const params = res.split(',')
        this.ruleForm.pic = params[1]
        if (params.length > 0) {
          this.strimagebase64 = params[1]
        }
      })
    },
    remove() {
      this.ruleForm.pic = ''
    },
    async delect() {
      this.$confirm('是否删除选中的数据？', '提醒', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(async () => {
        let res = await this.$http.post('/picLibrary/deleteAll', {
          ids: this.Select
        })
        if(res.data.code == 200) {
          this.$message({
            type: 'success',
            message: '删除成功',
            center: true,
            offset: 50
          })
          this.list()
        }
      })
      .catch(action => {
        return false;
      })
    },
    async del(id) {
        this.$confirm('是否删除此条数据？', '提醒', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
        }).then(async () => {
            let res = await this.$http.post('/picLibrary/delete', {
                id: id
            })
            if(res.data.code == 200) {
                this.$message({
                    type: 'success',
                    message: '删除成功',
                    center: true,
                    offset: 50
                })
                this.list()
            }
        })
        .catch(action => {
            return false;
        })
    },
    update() {
        this.$refs.ruleForm.validate(async (valid) => {
            if (valid) {
                let res = await this.$http.post('/picLibrary/saveOrUpdate', {
                    id: this.id ? this.id : null,
                    name: this.ruleForm.name,
                    image: this.ruleForm.pic
                })
                if(res.data.code == 200) {
                    this.$message({
                        type: 'success',
                        message: this.id ? '编辑成功' : '添加成功',
                        center: true,
                        offset: 50
                    })
                    this.list()
                    this.neir = false
                }
            } else {
                return false;
            }
        })
    },
    async handleEdit(id) {
        this.id = id
        this.fileList = []
        let res = await this.$http.post('/picLibrary/getPicLibraryById', {
            id: id
        })
        if(res.data.code == 200) {
            this.ruleForm.name = res.data.data.name
            this.ruleForm.pic = res.data.data.image
            const obj = {
                url: res.data.data.image,
                name: 'img'
            }
            this.fileList.push(obj)
            this.neir = true
        }
    },
    add() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let res = await this.$http.post('/productCategory/saveOrUpdate', {
            id: this.id ? this.id : null,
            pcName: this.ruleForm.name,
            parentId: this.ruleForm.falb ? this.ruleForm.falb : null,
            outline: this.ruleForm.outline,
            sort: this.ruleForm.sort
          })
          if(res.data.code == 200) {
            this.$message({
              type: 'success',
              message: this.id ? '编辑成功' : '添加成功',
              center: true,
              offset: 50
            })
            this.list()
            this.newsadd = false;
          }
        } else {
          return false;
        }
      })
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.list()
    }
  },
  watch: {
    neir: {
      handler(news, old) {
        if(news == false) {
            this.$refs.pic.clearFiles()
            this.$refs.ruleForm.resetFields()
            this.ruleForm.name = ''
            this.ruleForm.pic = ''
            this.id = null
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.box{
  padding: 10px;
  background-color: #fff;
}
</style>